import Swal from "sweetalert2";
import ErrorDisplay from '@/components/base/ErrorDisplay.vue';
import { createApp, h } from 'vue'
import { defineComponent } from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default defineComponent({
  components: { FontAwesomeIcon },
})


export const AlertConfigurations = {
    triggerSwal(action, text) {
        Swal.fire({
            title: action,
            iconHtml: "<div class='spinner-border fs-2 text-secondary' style='width: 5rem; height: 5rem;' role='status'></div>",
            showConfirmButton: false,
            text: text,
            allowOutsideClick: false,
            allowEscapeKey: false
        })
    },
    confirmLogOutAlert (){
        return Swal.fire({
            title: 'Logout?',
            text: 'Are you sure you want to logout?',
            confirmButtonText: 'Logout',
            confirmButtonColor: '#0d6efd',
            cancelButtonColor: 'var(--app-dark-gray)',
            showCancelButton: true,
        }).then((logout) => {
            if(logout.isConfirmed){
                // logoutUser()
            }
        })
    },
    successAlert(text, action) {
        return Swal.fire({
            title: action,
            icon: `success`,
            text: text,
            showConfirmButton: false,
            timer: 3000
        })
    },
    async confirmAlert(text, action, confirm_text='Yes') {
        return await Swal.fire({
            title: action,
            icon: "question",
            text: text,
            confirmButtonText: confirm_text,
            confirmButtonColor: '#0d6efd',
            showCancelButton: true,
        }).then(response => response.isConfirmed)
    },
    async confirmDeleteAlert(text, action,confirm_text='Proceed to delete') {
        return await Swal.fire({
            title: action,
            icon: "warning",
            iconColor: '#FF4343',
            text: text,
            confirmButtonText: confirm_text,
            confirmButtonColor: '#FF4343',
            cancelButtonColor: '#a3a3a3',
            showCancelButton: true,
        }).then(response => response.isConfirmed)
    },
    async confirmCancellationAlert(text, action, confirm_text) {
        return await Swal.fire({
            title: action,
            icon: "warning",
            iconColor: '#FF4343',
            text: text,
            confirmButtonText: confirm_text,
            confirmButtonColor: '#FF4343',
            cancelButtonColor: '#ababab',
            showCancelButton: true,
        }).then(response => response.isConfirmed)
    },
    async confirmLeaveFormAlert() {
        return await Swal.fire({
            title: 'You have unsaved changes!',
            icon: 'warning',
            text: 'You will lose all your changes. Are you sure you wish to leave?',
            confirmButtonText: 'Proceed to leave',
            confirmButtonColor: '#0d6efd',
            cancelButtonColor: 'var(--app-dark-gray)',
            showCancelButton: true,
        }).then(response => response.isConfirmed)
    },
    async discardChangesAlert(options = {}) {
      const {
        title = 'Unsaved Changes',
        text = 'Do you want to save your changes? Unsaved progress will be lost.',
        confirmText = 'Save',
        denyText = 'Discard',
        cancelText = 'Keep Editing',
        confirmColor = '#3085d6',
        denyColor = '#d33',
        icon = 'warning'
      } = options

      const result = await Swal.fire({
        title: title,
        text: text,
        icon: icon,
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: confirmText,
        denyButtonText: denyText,
        cancelButtonText: cancelText,
        confirmButtonColor: confirmColor,
        denyButtonColor: denyColor,
      })

      return result.isConfirmed
        ? 'save'
        : result.isDenied
          ? 'discard'
          : 'cancel'
    },

    failedAlert (text, action) {
        return Swal.fire({
            title: action,
            icon: `error`,
            text: text,
        })
    },


    warningAlert(text, action, confirm_text = 'Yes', icon = 'triangle-exclamation') {

      const iconContainer = document.createElement('div')

      createApp({
        render() {
          return h(FontAwesomeIcon, {
            icon: ['fas', icon],
            style: {
              color: 'var(--bs-warning)',
              fontSize: '3.5rem'
            }
          })
        }
      }).mount(iconContainer)

      return Swal.fire({
        title: action,
        text: text,
        icon: null,
        type: 'warning',
        iconHtml: iconContainer.innerHTML,
        confirmButtonText: confirm_text,
        confirmButtonColor: '#dc3545',
         customClass: {
          icon: 'swal-warning-custom-icon'
        }
      })
    },

    loadingAlert (text, action) {
        return Swal.fire({
            title: action,
            iconHtml: "<div class='spinner-border fs-2 text-secondary' style='width: 5rem; height: 5rem;' role='status'></div>",
             text: text,
              timerProgressBar: false,
               allowEscapeKey: false,
              showConfirmButton : false,
              allowOutsideClick : false,
        })
    },
    infoAlert(text, action) {
        return Swal.fire({
            title: action,
            icon: 'warning',
            text: text,
            timer: 3000
        })
    },
    toastNotification (text, action, icon, time = 2250) {
         return Swal.fire({
            toast: true,
            title: action,
            icon: icon,
            text: text,
            timer: time,
            showConfirmButton: false,
            position: 'top-right'
        })
    },
    validationErrorAlert(title, errors) {
      const container = document.createElement('div');
       createApp(ErrorDisplay, { errors: errors }).mount(container);

      return Swal.fire({
      html: container,
      icon: null,
      width: '550px',
      confirmButtonText: 'Understood',
      confirmButtonColor: '#dc3545',
      customClass: {
                      popup: 'rounded-4',
                      confirmButton: 'px-5 py-2 fw-bold'
                    },
      buttonsStyling: true,
      showCloseButton: true
      });
    },

   async customConfirmSlotAlert(action, domElement, validationCallback, confirm_text = 'Submit') {
     const originalParent = domElement.parentNode;

    return await Swal.fire({
      title: '',
      html: domElement,
      icon: " ",
      showCancelButton: true,
      confirmButtonText: confirm_text,
      confirmButtonColor: '#0d6efd',
      cancelButtonColor: '#ababab',
      customClass: {
        htmlContainer: 'overflow-visible'
      },
      preConfirm: () => {
         if (validationCallback) {
          const errorMsg = validationCallback();
          if (errorMsg) {
            Swal.showValidationMessage(errorMsg);
            return false;
          }
        }
      },
      willClose: () => {
         if (originalParent) {
          originalParent.appendChild(domElement);
        }
      }
    }).then(response => response.isConfirmed);
  },

  closeAlert () {
    Swal.close();
  }
}
